import { render, staticRenderFns } from "./P009.vue?vue&type=template&id=12897862"
import script from "./P009.vue?vue&type=script&lang=js"
export * from "./P009.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports